import React from 'react'
import moment from 'moment'
import { Popover } from 'antd';
import OverflowToolTip from '../../shared/OverflowToolTip';
import { NavLink } from 'react-router-dom';

/**
 * The `DealInfo` component is a React functional component that displays information about a deal,
 * including deal amount, company type, date, type, sector, exit status, stake, city, region, website,
 * and news links.
 * @returns The DealInfo component is returning a JSX element.
 */
const DealInfo = (props) => {
    return (
        <div className="px-5 ">
            <p
                className="  text-[14pt] leading-[19pt] lg:text-[17px] text-[#333333] font-semibold lg:leading-[22px]">
                Deal Info</p>
            <div className="overflow-x-auto scrollbar mt-2">
                {props?.data ?
                    <div className="w-full space-y-4">
                        {/* First Row */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-b border-[#E5E5E5]">
                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto">
                                    Deal Amount ($M)
                                </p>
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold">
                                    {props?.data?.DealAmount == 0 || props?.data?.DealAmount === "--" ? "--" : props?.data?.DealAmount ? '$ ' + props?.data?.DealAmount + ' M' : "--"}
                                </p>
                            </div>

                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto">
                                    Company Type
                                </p>
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold">
                                    {props?.data?.CompanyType == 0 ? "--" : props?.data?.CompanyType ? props?.data?.CompanyType : "--"}
                                </p>
                            </div>

                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto">
                                    Date
                                </p>
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold">
                                    {props?.data?.Date ? moment(props?.data?.Date, "MMM YYYY").format("MMM YYYY") : "--"}
                                </p>
                            </div>
                        </div>

                        {/* Second Row */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-b border-[#E5E5E5]">
                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto">
                                    Sector
                                </p>
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold">
                                    {props?.data?.Type == 0 ? "--" : props?.data?.Type ? props?.data?.Type : "--"}
                                </p>
                            </div>

                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto">
                                    Sub Sector
                                </p>
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold">
                                    {props?.data?.Sector == 0 ? "--" : props?.data?.Sector ? props?.data?.Sector : "--"}
                                </p>
                            </div>

                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto">
                                    Exit Status
                                </p>
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold">
                                    {props?.data?.ExitStatus ? props?.data?.ExitStatus : "--"}
                                </p>
                            </div>
                        </div>

                        {/* Third Row */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-b border-[#E5E5E5]">
                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto">
                                    Stake
                                </p>
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold">
                                    {(props?.data?.Stake == 0 || props?.data?.Stake == '0.00%' || props?.data?.Stake == '0%') ? "--" : props?.data?.Stake ? props?.data?.Stake : "--"}
                                </p>
                            </div>

                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto">
                                    City(Project Location)
                                </p>
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold">
                                    {props?.data?.City == 0 ? "--" : props?.data?.City ? props?.data?.City : "--"}
                                </p>
                            </div>

                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto">
                                    Region
                                </p>
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] whitespace-nowrap cursor-auto font-semibold">
                                    {props?.data?.Region == 0 ? "--" : props?.data?.Region ? props?.data?.Region : "--"}
                                </p>
                            </div>
                        </div>

                        {/* Fourth Row */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto">
                                    Website
                                </p>
                                <div className="max-w-[90%]">
                                    {props?.data?.Website == 0 ? "--" : props?.data?.Website ? 
                                        <Popover
                                            placement="topLeft"
                                            content={
                                                <a
                                                    className="text-[11pt] hover:text-[#A5711A] leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto font-semibold hover:underline break-all"
                                                    href={props?.data?.Website}
                                                    target="_blank"
                                                    rel='noreferrer'
                                                >
                                                    {props?.data?.Website}
                                                </a>
                                            }
                                        >
                                            <NavLink 
                                                className="text-[11pt] cursor-pointer leading-[18pt] lg:text-[13px] text-[#333333] font-semibold hover:text-[#BC8B20] hover:underline block truncate"
                                                to={props?.data?.Website}
                                                target='_blank'
                                            >
                                                {props?.data?.Website}
                                            </NavLink>
                                        </Popover>
                                        : "--"
                                    }
                                </div>
                            </div>

                            <div className="py-1 lg:leading-[21px] font-sans_book_body">
                                <p className="text-[11pt] leading-[18pt] lg:text-[14px] text-[#333333] whitespace-nowrap cursor-auto">
                                    News Link
                                </p>
                                <div className="max-w-full">
                                    {props?.data?.NewsLink ?
                                        props?.data?.NewsLink?.split(";")?.filter(link => link?.trim().length !== 0).length === 0 ? "--" :
                                            <div className="truncate">
                                                {props?.data?.NewsLink?.split(";")?.filter(link => link?.trim().length !== 0)?.map((link, index) => {
                                                    return <Popover
                                                        key={index}
                                                        placement="topLeft"
                                                        content={
                                                            <a
                                                                className="text-[11pt] hover:text-[#A5711A] leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto font-semibold hover:underline"
                                                                href={link} 
                                                                target="_blank" 
                                                                rel='noreferrer'
                                                            >
                                                                {link}
                                                            </a>
                                                        }
                                                    >
                                                        <a
                                                            className="text-[11pt] leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto font-semibold hover:underline inline"
                                                            href={link} 
                                                            target="_blank" 
                                                            rel='noreferrer'
                                                        >
                                                            Link {index + 1}{props?.data?.NewsLink?.split(";")?.filter(link => link?.trim().length !== 0).length > index + 1 ? ", " : ""}
                                                        </a>
                                                    </Popover>
                                                })}
                                            </div>
                                        : "--"}
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="w-full bg-[#FFFFFF]">
                        <center><div role="status" className=" h-[8rem]">
                            <svg className="relative top-[4rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                            </svg>
                        </div></center>
                    </div>
                }
            </div>
        </div>
    )
}

export default DealInfo
